import { createAction, createAsyncThunk, createSlice, PrepareAction } from '@reduxjs/toolkit';
import { LoginUserModel } from '@app/domain/LoginUserModel';

import { persistUser } from '@app/services/localStorage.service';
import { getUserById, updateUserById, updateUserByIdAsync } from '@app/api/user.api';

export interface UserState {
  user: LoginUserModel | null;
}

const initialState: UserState = {
  user: null,
};

export const fetchLoginUserById = createAsyncThunk('user/setLoginUser', async (id: number) =>
  getUserById(id).then((res) => {
    return res;
  }),
);

export const updateLoginUserById = createAsyncThunk(
  'user/updateLoginUser',
  async ({ id, data }: { id: number; data: LoginUserModel }) =>
    updateUserById(id, data).then((res) => {
      return res;
    }),
);

export const updateLoginUserByIdAsync = createAsyncThunk(
  'user/updateLoginUserAsync',
  // eslint-disable-next-line
  async ({ id, data }: { id: number; data: any }) =>
    updateUserByIdAsync(id, data).then((res) => {
      return res;
    }),
);

export const setUser = createAction<PrepareAction<LoginUserModel>>('user/setUser', (newUser) => {
  persistUser(newUser);

  return {
    payload: newUser,
  };
});

export const userSlice = createSlice({
  name: 'user',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(fetchLoginUserById.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(updateLoginUserByIdAsync.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(fetchLoginUserById.rejected, (state) => {
      state.user = null;
    });
    builder.addCase(updateLoginUserById.fulfilled, (state, action) => {
      state.user = action.payload;
    });
    builder.addCase(setUser, (state, action) => {
      state.user = action.payload;
    });
  },
});

export default userSlice.reducer;
